// extracted by mini-css-extract-plugin
export default {"key":"KeyboardKey-module_key_XYvTY"};